import { IconDefinition } from '@ant-design/icons-angular';

export const MkbEnvelopeOutline: IconDefinition = {
    name: 'mkb-envelope',
    theme: 'outline',
    icon: `<svg viewBox="0 0 20 20"><defs><style /></defs>
    <path d="M17.842 6.29901L11.842 1.63201C10.759 0.789006 9.242 0.789006 8.158 1.63201L2.158 6.29901C1.427 6.86701 1 7.74101 1 8.66701V16C1 17.657 2.343 19 4 19H16C17.657 19 19 17.657 19 16V8.66701C19 7.74101 18.573 6.86701 17.842 6.29901Z" stroke-width="1.1"/>
    <path d="M7 15H13" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`
}